import { IMenuHref, IPage, IRouteLink, localize } from '@websolutespa/bom-core';
import { useLayout, usePage } from '@websolutespa/bom-mixer-hooks';
import { resolveHref } from '@websolutespa/bom-mixer-models';
import { StructuredData } from '@websolutespa/bom-mixer-ui';

export type BreadcrumbStructuredDataProps = {
  items?: (IRouteLink | IMenuHref)[];
};

export const BreadcrumbStructuredData = ({ items }: BreadcrumbStructuredDataProps = {}) => {
  const page = usePage() as IPage & { breadcrumb: IRouteLink[] };
  const layout = useLayout();
  const breadcrumb = items || page.breadcrumb;

  if (!breadcrumb || breadcrumb.length === 0) {
    return null;
  }

  let finalBreadcrumb = breadcrumb;
  if (finalBreadcrumb.length > 0) {
    const firstHref = resolveHref(finalBreadcrumb[0].href);
    const homeHref = resolveHref(layout.topLevelHrefs?.homepage);
    if (firstHref !== homeHref) {
      finalBreadcrumb = [{ title: 'Home', href: layout.topLevelHrefs?.homepage } as IRouteLink, ...finalBreadcrumb];
    }
  }

  return (
    <StructuredData item={() => ({
      '@type': 'BreadcrumbList' as const,
      itemListElement: finalBreadcrumb.map((item, i) => ({
        '@type': 'ListItem' as const,
        position: i + 1,
        name: typeof item.title === 'string' ? item.title : localize(item.title, page.locale),
        item: resolveHref(item.href),
      })),
    })} />
  );
};
